import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { PvzKeys } from 'sections/LKSection/modules/PvzModule/data'
import { PvzFeature } from 'sections/LKSection/modules/PvzModule/types/types'
import { Margin } from 'components/ui'
import { Checkbox, Flex, Form, FormItem, Title } from 'components/uiKit'

type PvzFeaturesFormProps = {
  disabled: boolean
}

const getKey = (key: string) => `${PvzKeys.pvzItemPage}.${key}`

export const PvzFeaturesForm = observer(({ disabled }: PvzFeaturesFormProps) => {
  const { viewPvzUiStore: uiStore } = useStore()

  const { t } = useTranslation()

  const featuresChangeHandler = (feature: PvzFeature, value: boolean) => {
    uiStore.setFeatures(
      uiStore.features.map((item) => ({
        ...item,
        checked: item.label === feature.label ? value : item.checked,
      })),
    )
  }

  return (
    <Form>
      <Margin mb={16}>
        <Title level={5}>{t(getKey('Удобства на ПВЗ'))}</Title>
      </Margin>

      <FormItem>
        {uiStore.features.map((feature) => (
          <Flex key={feature.label} vertical align="start">
            <Checkbox
              checked={feature.checked}
              onChange={(e) => featuresChangeHandler(feature, e.target.checked)}
              disabled={disabled}
            >
              {feature.label}
            </Checkbox>
          </Flex>
        ))}
      </FormItem>
    </Form>
  )
})
